import { fetchToken, selectExpirationDate, selectIsLoggedIn, selectUser, updateUser, updateNotification } from 'containers/Login/loginSlice'
import { resetAccount } from 'containers/Account/accountSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import { /* useContext, */ useEffect, useRef } from 'react'
// import FCMContext from 'context/firebase/Context'

const Auth: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const expirationDate = useReduxSelector(selectExpirationDate)
  const isLogIn = useReduxSelector(selectIsLoggedIn)
  const user = useReduxSelector(selectUser)
  const currentUser = useRef(user)
  currentUser.current = user

  const dispatch = useReduxDispatch()
  // const { registerFCM } = useContext(FCMContext)

  useEffect(() => {
    if (isLogIn && expirationDate) {
      let interval = setInterval(() => dispatch(fetchToken()), expirationDate)
      return () => clearInterval(interval)
    }
  }, [dispatch, expirationDate, isLogIn])

  useEffect(() => {
    if (isLogIn) {
      // registerFCM()
      return () => { dispatch(resetAccount()) }
    }
  }, [dispatch, isLogIn/* , registerFCM */])

  useEffect(() => {
    const onNotificationStatusChanged = (event: Event) => {
      const status = (event as CustomEvent<{ state: boolean, isNewState: boolean } | boolean>).detail
      const notification = typeof status === 'object'
        ? status.isNewState
          ? status.state
          : (status.state && !!currentUser.current?.hasPushNotification)
        : status
      console.log(`Nowy status powiadomień: ${notification}`)
      dispatch(updateNotification(notification))

      if (typeof status === 'object') {
        console.log(`Status powiadomień: { state:${status.state}, isNewState:${status.isNewState} }`)
        if (status.isNewState) {
          dispatch(updateUser({ hasPushNotification: notification }))
        }
      }
    }

    window.addEventListener('nativeNotificationStatus', onNotificationStatusChanged)
    return () => {
      window.removeEventListener('nativeNotificationStatus', onNotificationStatusChanged)
    }
  }, [dispatch])

  return children
}

export default Auth